let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("aHG2I"), load("bJvam"), load("e7a0j")]).then(() => parcelRequire('lcbzD'));